import { render, staticRenderFns } from "./booking-invoice.vue?vue&type=template&id=dd706b04&scoped=true"
import script from "./booking-invoice.vue?vue&type=script&lang=js"
export * from "./booking-invoice.vue?vue&type=script&lang=js"
import style0 from "./booking-invoice.vue?vue&type=style&index=0&id=dd706b04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd706b04",
  null
  
)

export default component.exports